import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { BACKEND_URL } from './constants';
import { getToken } from '../../services/tokenService';

const COULEURS = ['#f97316', '#1e3a5f', '#0e6b4e', '#9333ea', '#dc2626', '#0891b2', '#ca8a04'];
const MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
const libMois = (m) => `${MOIS[Number(m.slice(5, 7)) - 1]} ${m.slice(2, 4)}`;
const eur = (v) => (Number(v) || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + ' €';

// Courbe des contributions encaissées mois par mois, une ligne par dispositif
export default function CourbeMensuelle({ debut, fin }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/recus-ess/recap-contributions/mensuel?debut=${debut}&fin=${fin}`, { headers: { Authorization: `Bearer ${getToken()}` } })
      .then(({ data: d }) => setData(d)).catch(() => setData({ mois: [], dispositifs: [], points: [] }));
  }, [debut, fin]);

  if (!data) return null;
  if (!data.points.length) return null;
  return (
    <div className="border rounded-xl p-4" data-testid="recap-courbe-mensuelle">
      <p className="text-sm font-semibold text-gray-700 mb-3">Contributions encaissées par mois</p>
      <div style={{ width: '100%', height: 280 }}>
        <ResponsiveContainer>
          <LineChart data={data.points} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="mois" tickFormatter={libMois} tick={{ fontSize: 11 }} />
            <YAxis tickFormatter={eur} tick={{ fontSize: 11 }} width={80} />
            <Tooltip formatter={(v, n) => [eur(v), n]} labelFormatter={libMois} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {data.dispositifs.map((d, i) => (
              <Line key={d} type="monotone" dataKey={d} stroke={COULEURS[i % COULEURS.length]} strokeWidth={2} dot={{ r: 3 }} />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
